export default {
    errorModalGenericTitle:"Caution",
    errorModalGenericDescription:"An error has occurred. Please try again. ",
    reportError:'If the problem persists, you may report the error by means of the consultation system by clicking',
    mailTo:'mailto:sac@plataforma10.com',
    clickHere:'here.'
}